import type { FluxErrorEntityErrorCodes } from '../../types.js';

export const AutomationV2ExecutionActionCreateCardReviewCodes = {
  AutomationV2ExecutionActionCreateCardReviewFailedToCancelPendingReview: {
    code: 'automation-v2-execution-action/create-card-review-failed-to-cancel-pending-review',
    explanation: `Falha ao tentar substituir uma revisão de card existente.

**Causas comuns:**
- O sistema não conseguiu cancelar a revisão anterior devido a restrições de estado
- Concorrência de atualizações no mesmo card

**Como resolver:**
Verifique se é possível configurar a automação para aguardar ou ignorar se já houver revisão.`,
    localizations: {},
    message: 'Existe uma revisão pendente para este card e não é possível cancelar a revisão.',
    supportingDocs: [
      {
        name: 'Ação de Criar Revisão de Card',
        path: '/wiki/docs/automations/actions/create-card-review',
      },
    ],
  },
  AutomationV2ExecutionActionCreateCardReviewFailedToCreateReview: {
    code: 'automation-v2-execution-action/create-card-review-failed-to-create-review',
    explanation: `Erro genérico ao criar a revisão.

**Causas comuns:**
- Dados inválidos no template de revisão
- Configurações de fase de revisão inválidas

**Como diagnosticar:**
Revise as configurações da ação de criação de revisão.`,
    localizations: {},
    message: 'Houve um erro ao tentar criar a revisão do card.',
    supportingDocs: [
      {
        name: 'Ação de Criar Revisão de Card',
        path: '/wiki/docs/automations/actions/create-card-review',
      },
    ],
  },
  AutomationV2ExecutionActionCreateCardReviewMissingCardId: {
    code: 'automation-v2-execution-action/create-card-review-missing-card-id',
    explanation: `ID do card é obrigatório no contexto da ação. O id do card é automaticamente passado pelo gatilho ou por ações anteriores.

**Causas comuns:**
- Variável cardId não resolvida
- Caso o valor do cardId seja mapeado manualmente, pode ter sido digitado incorretamente.
- Caso o valor do cardId não tenha sido mapeado, o \`context.card.id\` não está disponível.

**Como resolver:**
Corrija o mapeamento do ID do card.`,
    localizations: {},
    message:
      'Não foi possível criar a revisão do card porque o ID do card está faltando. Verifique se o card existe no contexto da automação ou se foi digitado corretamente.',
    supportingDocs: [
      {
        name: 'Ação de Criar Revisão de Card',
        path: '/wiki/docs/automations/actions/create-card-review',
      },
    ],
  },
  AutomationV2ExecutionActionCreateCardReviewMissingTemplateId: {
    code: 'automation-v2-execution-action/create-card-review-missing-template-id',
    explanation: `O Template de Revisão não foi especificado.

**Causas comuns:**
- Template deletado
- Configuração da ação incompleta

**Como resolver:**
Selecione um template de revisão válido na configuração da ação.`,
    localizations: {},
    message:
      'Não foi possível criar a revisão do card porque o ID do template está faltando. Verifique se o template existe no contexto da automação ou se foi digitado corretamente.',
    supportingDocs: [
      {
        name: 'Ação de Criar Revisão de Card',
        path: '/wiki/docs/automations/actions/create-card-review',
      },
      {
        name: 'Informações Dinâmicas',
        path: '/wiki/docs/automations/informacoes-dinamicas',
      },
    ],
  },
  AutomationV2ExecutionActionCreateCardReviewPendingReviewAlreadyExists: {
    code: 'automation-v2-execution-action/create-card-review-pending-review-already-exists',
    explanation: `A ação foi abortada porque já existe uma revisão pendente, conforme configurado.

**Causas comuns:**
- Comportamento padrão de "Skip" (pular) quando duplicado
- Trigger disparado múltiplas vezes rápidas

**Como resolver:**
Isso geralmente é o comportamento esperado. Se deseja sobrescrever, altere a configuração da ação.`,
    localizations: {},
    message:
      'Já existe uma revisão pendente para este card e o comportamento definido é de não criar uma nova revisão.',
    supportingDocs: [
      {
        name: 'Ação de Criar Revisão de Card',
        path: '/wiki/docs/automations/actions/create-card-review',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation-v2-execution-action'>;
